export default "__VITE_ASSET__Dq0U3cgi__"